import { FC } from 'react';

import compose from '../../../utils/components/_compose';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';

import Tooltip, { TooltipProps } from './Tooltip';

export * from './Tooltip';

export default compose<FC<TooltipProps>>(
  withUniqueId('tooltipId'),
)(Tooltip);
